<cc-sub-nav-on-lobby-type [lobbyType]="lobbyTypePathSegment" [stickyInputQueryElement]="'cs-games-sub-nav-section'"></cc-sub-nav-on-lobby-type>
